import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-filter-modal',
  standalone: true,
  imports: [ReactiveFormsModule, TranslateModule],
  templateUrl: './filter-modal.component.html',
  styleUrls: ['./filter-modal.component.scss'],
})
export class FilterModalComponent implements OnInit {
  @Output() filtersChanged = new EventEmitter<any>();
  filterForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<FilterModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { initialFilters: any }
  ) {
    this.filterForm = this.fb.group({
      lastUsedFrom: ['', [Validators.pattern(/^\d{4}-\d{2}-\d{2}$/)]],
      lastUsedTo: ['', [Validators.pattern(/^\d{4}-\d{2}-\d{2}$/)]],
      lastCalibrationFrom: ['', [Validators.pattern(/^\d{4}-\d{2}-\d{2}$/)]],
      lastCalibrationTo: ['', [Validators.pattern(/^\d{4}-\d{2}-\d{2}$/)]],
      companyName: [''],
      modelName: [''],
      siteName: [''],
    });
  }

  ngOnInit(): void {
    if (this.data?.initialFilters) {
      this.filterForm.patchValue(this.data.initialFilters);
    }
  }

  applyFilters(): void {
    if (this.filterForm.valid) {
      this.filtersChanged.emit(this.filterForm.value);
      this.dialogRef.close();
    } else {
      console.warn('Form is invalid:', this.filterForm.errors);
    }
  }

  resetFilters(): void {
    this.filterForm.reset({
      lastUsedFrom: '',
      lastUsedTo: '',
      lastCalibrationFrom: '',
      lastCalibrationTo: '',
      companyName: '',
      modelName: '',
      siteName: '',
    });
    this.filtersChanged.emit({});
    this.closeDialog();
  }

  closeDialog(): void {
    this.dialogRef.close(null);
  }
}
